import React, {Component, Fragment, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import MatchResultCard from "./match_and_event_match_report/MatchResultCard";
import liverpoolLogo from "../../../assets/img/demo/liverpool-logo.png";
import brightonAndHoveAlbionLogo from '../../../assets/img/demo/brighton-and-hove-albion-logo@32x32.png';

import dustinWilliamsonAvatar from "../../../assets/img/demo/dustin-williamson-avatar.png";
import darrellMckinneyAvatar from "../../../assets/img/demo/darrell-mckinney-avatar.png";
import eduardoMilesAvatar from "../../../assets/img/demo/eduardo-miles-avatar.png";
import brandonPenaAvatar from "../../../assets/img/demo/brandon-pena-avatar.png";
import '../../../assets/sass/pages/match-and-event-match-report.scss';
import PlayerPositions from "./match_and_event_match_report/PlayerPositions";
import MatchAndEventMatchReportCard from "./match_and_event_match_report/MatchAndEventMatchReportCard";
import MatchStats from "./match_and_event_match_report/MatchStats";
import ShadowScrollbars from "../../ui/custom_scrollbars/ShadowScrollbars";
import MatchVideos from "./match_and_event_match_report/MatchVideos";
import matchVideoThumbnail from "../../../assets/img/demo/matchVideoThumbnail.png";
import {gql, useQuery} from "@apollo/client";
import Tools from "../../../Tools";
import NoError from "../../ui/feedback/NoError";
import NoResultFound from "../../ui/feedback/NoResultFound";
import MatchesResults from "./matches_and_events/results/MatchesResults";
import Loading from "../../ui/feedback/Loading";

class MatchAndEventMatchReport extends Component {
    render = () => {
        return (
            <Fragment>
                {this.renderPageTitle()}
                {this.renderMatchTitle()}
                {this.renderCards()}
            </Fragment>
        )
    };

    /**
     * Render title of page.
     * @returns {React.ReactNode} The page title div.
     */
    renderPageTitle = () => {
        const {pageTitle} = this.props;
        return (<div className="page-title"> {pageTitle} </div>);
    };
    /**
     * Render title of page.
     * @returns {React.ReactNode} The page title div.
     */
    renderMatchTitle = () => {
        const {matchTitle} = this.props;
        return (<div className="match-title"> {matchTitle} </div>);
    };

    renderCards = () => {
        const matchId = this.props?.match?.params?.id;
        return (
            <MatchAndEventMatchReport.Cards matchId={matchId}/>
        );

    };


    static defaultProps = {
        // The title of the page shown in the top left corner.
        pageTitle: "Match report",

        matchTitle: "Liverpool vs Brighton & Hove Albion"
    };
}

const MatchAndEventMatchReportCards = props => {
    const query = gql`
        query getMatch ($id: String!){
            match: getMatch (id: $id){
                homeTeam{
                    team{
                        name
                        logo
                    }
                }
                awayTeam{
                    team{
                        name
                        logo
                    }
                }
                goals{
                    team{
                        name
                    }
                    soccer{
                        name
                        avatar
                        careerStats{
                            redCards
                            yellowCards
                        }
                    }
                    time
                }

                shots{
                    onGoal

                }
                possession{
                    homeTeam
                    awayTeam
                }
            }
            stats: getMatchStatsNumber(id: $id){
                homeTeam{
                    fouls
                    yellowCard
                    redCard
                    offsides
                    cornerKicks
                    saves
                    shotsOnGoal
                    ballPossession
                }
                awayTeam{
                    fouls
                    yellowCard
                    redCard
                    offsides
                    cornerKicks
                    saves
                    shotsOnGoal
                    ballPossession
                }
            }
            videos: getMatchStats(id: $id){
                videos{
                    title
                    #                    duration
                    videoUrls{
                        url
                        extension
                        resolution
                    }
                }
            }
        }
    `;

    const formatCard = player => player.careerStats.redCards ? 'red' : player.careerStats.yellowCards ? 'yellow' : undefined;

    const formatGoals = goals => goals.map(goal => ({
        player: {
            name: goal.soccer.name,
            avatar: goal.soccer.avatar,
            sniper: true,
            card: formatCard(goal.soccer),
        },
        time: goal.time
    }));

    const formatMatch = match => {
        if (!match)
            return null;

        const {team: homeTeam} = match.homeTeam;
        const {team: awayTeam} = match.awayTeam;
        const {goals} = match;
        const homeTeamGoals = goals.filter(goal => goal.team.name === homeTeam.name);
        const awayTeamGoals = goals.filter(goal => goal.team.name === awayTeam.name);

        return {
            team1: {
                name: homeTeam.name,
                logo: homeTeam.logo,
                score: homeTeamGoals.length,
                goals: formatGoals(homeTeamGoals),
                plan: {
                    formation: '4-5-1',
                    playersPositions: [
                        {x: 0, y: -550, number: '5', goalkeeper: true},
                        {x: -200, y: -350, number: '24'},
                        {x: 200, y: -350, number: '5'},
                        {x: -350, y: -250, number: '44'},
                        {x: 350, y: -250, number: '34'},
                        {x: 0, y: -15, number: '18'},
                        {x: -150, y: 100, number: '22'},
                        {x: 150, y: 100, number: '8'},
                        {x: 0, y: 400, number: '9'},
                        {x: -350, y: 450, number: '11'},
                        {x: 350, y: 450, number: '7'},
                    ],
                }
            },
            team2: {
                name: awayTeam.name,
                logo: awayTeam.logo,
                score: awayTeamGoals.length,
                goals: formatGoals(awayTeamGoals),
                plan: {
                    formation: '4-2-3-1',
                    playersPositions: [
                        {x: 0, y: -550, number: '21', goalkeeper: true},
                        {x: -200, y: -350, number: '13'},
                        {x: 200, y: -350, number: '5'},
                        {x: -350, y: -250, number: '39'},
                        {x: 350, y: -250, number: '7'},
                        {x: 0, y: -15, number: '77'},
                        {x: -400, y: 0, number: '14'},
                        {x: 400, y: 0, number: '34'},
                        {x: 0, y: 175, number: '8'},
                        {x: -200, y: 400, number: '30'},
                        {x: 200, y: 400, number: '10'},
                    ],
                },
            }
        };
    };

    const formatStats = stats => {
        if (!stats)
            return null;

        return {
            team1: stats.homeTeam,
            team2: stats.awayTeam
        };
    };

    const formatter = (match, stats) => {
        const formattedMatch = formatMatch(match);
        const formattedStats = formatStats(stats);
        return {
            ...formattedMatch,
            team1: {
                ...formattedMatch.team1,
                stats: formattedStats.team1,
            },
            team2: {
                ...formattedMatch.team2,
                stats: formattedStats.team2,
            }
        }
    };


    // Get filters values from props.
    const {matchId} = props;

    // Set request parameters.
    const variables = {
        id: matchId,
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables,
    });


    if (error) {
        return (
            <MatchAndEventMatchReport.Error error={error}/>
        );
    } else if (loading) {
        return (
            <MatchAndEventMatchReport.Loading/>
        );
    }

    console.log(data.videos);

    const match = formatter(data?.match, data?.stats);

    const videos = [
        {title: 'Full Match', duration: '90:30 Min', thumbnail: matchVideoThumbnail},
        {title: 'Fouls from liverpool', duration: '10 Min', thumbnail: matchVideoThumbnail},
        {title: 'Best actions of match', duration: '20:30 Min', thumbnail: matchVideoThumbnail},
        {title: 'Goals scored by James Williams', duration: '57 Sec', thumbnail: matchVideoThumbnail},
        {title: 'Full Match', duration: '90:30 Min', thumbnail: matchVideoThumbnail},
    ];

    return (
        ShadowScrollbars.wrapWithPadding(
            <Container fluid={true}>
                <Row className="matches-and-event-match-report-cards--row">
                    <Col xs={12} md={6} lg={6} className="matches-and-event-match-report-cards--col">
                        <MatchResultCard {...match}/>
                    </Col>
                    <Col xs={12} md={6} lg={6} className="matches-and-event-match-report-cards--col">
                        <PlayerPositions {...match}/>
                    </Col>
                    <Col xs={12} md={6} lg={6} className="matches-and-event-match-report-cards--col">
                        <MatchStats {...match}/>
                    </Col>
                    <Col xs={12} md={6} lg={6} className="matches-and-event-match-report-cards--col">
                        <MatchVideos videos={videos}/>
                    </Col>
                </Row>
            </Container>
        )
    );
};

MatchAndEventMatchReport.Cards = MatchAndEventMatchReportCards;
MatchAndEventMatchReport.Route = '/matches-and-events/report';

MatchAndEventMatchReport.Error = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <NoError text={"OOPS! Something went wrong"} details={"Error: " + props.error}/>
    </div>;

MatchAndEventMatchReport.Loading = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loading {...props}/>
    </div>;

export default MatchAndEventMatchReport;
